import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ToastContainer } from 'react-toastify';
import AppRoutes from './routes/AppRoutes';
import 'react-toastify/dist/ReactToastify.css';

// Detecta basename em runtime: funciona tanto no subdominio
// (central-max.trackmax.com.br/frontend/build) quanto no subpath
// antigo (trackmax.com.br/sistemas/centralmax/frontend/build)
const detectBasename = () => {
  if (typeof window === 'undefined') return '/';
  const { pathname } = window.location;
  const marker = '/frontend/build';
  const idx = pathname.indexOf(marker);
  if (idx >= 0) return pathname.substring(0, idx + marker.length);
  return '/';
};

function App() {
  return (
    <BrowserRouter basename={detectBasename()}>
      <AuthProvider>
        <AppRoutes />
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          closeOnClick
          pauseOnHover
          theme="colored"
        />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
